@if (show) {
  <div
    class="map-context-menu"
    [style.top.px]="position.top"
    [style.left.px]="position.left">

    @if (options.addPoint) {
      <div class="context-menu-item" (click)="onAddPoint()">
        <i class="pi pi-plus-circle"></i>
        <span>{{ 'ADD_POINT' | translate }}</span>
      </div>
    }
    @if (options.zoom) {
      <div class="context-menu-item" (click)="onZoom()">
        <i class="pi pi-search-plus"></i>
        <span>{{ 'ZOOM_REGION' | translate }}</span>
      </div>
    }
  </div>
}
